import { useRef, useState, useEffect, useContext } from "react";
import { FaTimes } from "react-icons/all";
import SEO from "../Components/SEO";

import UserContext from "../UserContext";

const Alert = ({ color, message }) => {
  const [status, setStatus] = useState("show");

  const removeAlert = () => {
    setStatus("hide");
  };

  if (status === "show")
    return (
      <div
        className={
          "py-3 px-4 shadow-sm border-2 border-l-8 border-" +
          color +
          "-400 border-r-0 flex justify-content-between align-items-center"
        }
      >
        <span className={"text-sm text-" + color + "-700"}>{message}</span>
        <button
          className={
            "bg-" +
            color +
            "-500 p-1 rounded-full focus:ring focus:ring-" +
            color +
            "-200"
          }
          onClick={removeAlert}
        >
          <FaTimes color="white" />
        </button>
      </div>
    );
  else return <></>;
};

export default function GuessingGamePage() {
  const numberContainer = useRef(null);

  // reveal input box states
  const [revealBox, setRevealBox] = useState(false);
  const [inputNumber, setInputNumber] = useState(-1);
  const [trials, setTrials] = useState(0);
  const [number, setNumber] = useState(Math.floor(Math.random() * 100));

  const MyAlert = ({ input }) => {
    if (input === -1) return <></>;
    else if (input === number) {
      window.Toast.fire({
        icon: "success",
        title:
          "🔥🔥 You won with (" +
          trials +
          ") Trials so your marks are (" +
          (21 - trials) * 5 +
          "/100 )",
      });
      return <Alert color="green" message="😎🔥 You've got it" />;
    } else if (input < number)
      return <Alert color="red" message={"(" + input + ") 😒😒 Too small"} />;
    else if (input > number)
      return <Alert color="red" message={"(" + input + ") 😱😱 Too long"} />;
  };

  const handleCheckNumber = () => {
    let asInt = parseInt(numberContainer.current.value);
    if (!isNaN(asInt)) {
      setTrials(trials + 1);
      setInputNumber(asInt);
    }
  };

  const restartGame = () => {
    setTrials(0);
    setInputNumber(-1);
    setNumber(Math.floor(Math.random() * 100));

    setRevealBox(!revealBox);

    if (numberContainer.current) numberContainer.current.value = "";
  };

  const { mode } = useContext(UserContext);
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  if (trials === 20)
    return (
      <div className="my-12" style={{ marginBottom: 200 }}>
        <h1 className="text-danger font-black text-center text-2xl">
          Game Over !!!{" "}
        </h1>
        <br />
        <div className="text-center">
          <button
            className="btn btn-danger"
            style={{ backgroundColor: "#f90202" }}
            onClick={restartGame}
          >
            Restart
          </button>
        </div>
      </div>
    );

  return (
    <>
      <SEO title={`Guessing Game`}></SEO>
      <div
        className="my-12 flex justify-content-center px-3"
        style={{ marginBottom: 200 }}
      >
        <div className="text-center">
          {!revealBox ? (
            <div>
              <h1 className="font-medium">Welcome to the guessing game</h1>
              <p className="mt-12 text-sm">
                You are going to guess a number chosen by the software between 0
                and 100. if the number of your choice is less than or <br />
                greater than we are going to tell it to you. You have 20 trials,
                the points you will get will be <br />
                marked according to trials you have tried. So good luck <br />
              </p>
            </div>
          ) : (
            ""
          )}
          <button
            className="bg-fire px-10 py-2 my-2 text-xs rounded-full text-white hover:opacity-50 focus:outline-none"
            onClick={() => {
              restartGame();
              setRevealBox(!revealBox);
            }}
          >
            {!revealBox ? "Start" : "End the game"}
          </button>

          {revealBox && (
            <div className="text-left mt-12">
              <div className="d-flex align-items-end">
                <div
                  className={
                    dark ? "flex-grow-1 pb-0.5 darkmode" : "flex-grow-1 pb-0.5"
                  }
                >
                  <label htmlFor="input">
                    Choose a number of your choice (between 0 and 100)
                  </label>
                  <input
                    type="number"
                    id="input"
                    placeholder="Enter a number"
                    ref={numberContainer}
                    className={
                      dark
                        ? "darkmode px-3 py-2 form-control border border-blue-900 w-100 my-0 focus:border focus:border-blue-900 focus:outline-none focus:ring focus:ring-blue-300"
                        : "px-3 py-2 form-control border border-blue-900 w-100 my-0 focus:border focus:border-blue-900 focus:outline-none focus:ring focus:ring-blue-300"
                    }
                    autoComplete="off"
                  />
                </div>
                <div className="pb-0.5 pl-1">
                  {number !== inputNumber ? (
                    <button
                      className="btn btn-danger"
                      style={{ backgroundColor: "#f90202" }}
                      onClick={handleCheckNumber}
                    >
                      Check
                    </button>
                  ) : (
                    <button
                      className="btn btn-danger"
                      style={{ backgroundColor: "#f90202" }}
                      onClick={restartGame}
                    >
                      Restart
                    </button>
                  )}
                </div>
              </div>
              <div className="mt-3 mb-12 pb-12">
                <MyAlert input={inputNumber} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
